export default __webpack_public_path__ + "static/media/ISBSession1.1295a247.JPG";